/* CK color leak — samples each card's own image and exposes per-side average
   colors as CSS vars (--leak-top/right/bottom/left). ck-dark-theme.css turns
   those into a thin, blurred, multi-color halo around the card. Pure progressive
   enhancement: if sampling is blocked (CORS/taint) or there's no real image,
   the card simply keeps its neutral border. Never affects layout. */
(function () {
  var TARGETS = [
    '.cs-build-tile',
    '.cs-home .cs-product-card',
    '.section-ck-related .ck-product-card'
  ].join(',');

  var scheduleWork = typeof window.requestIdleCallback === 'function'
    ? function (fn) { return window.requestIdleCallback(fn, { timeout: 1000 }); }
    : function (fn) { return setTimeout(fn, 16); };

  function boost(r, g, b) {
    // gently push colors away from grey so the leak reads as colour, not haze
    var avg = (r + g + b) / 3, k = 1.45;
    r = Math.max(0, Math.min(255, avg + (r - avg) * k));
    g = Math.max(0, Math.min(255, avg + (g - avg) * k));
    b = Math.max(0, Math.min(255, avg + (b - avg) * k));
    return 'rgb(' + (r | 0) + ',' + (g | 0) + ',' + (b | 0) + ')';
  }

  function sample(src, cb) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      scheduleWork(function () {
        try {
          var w = 32, h = 32;
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          function region(x0, y0, x1, y1) {
            var d = ctx.getImageData(x0, y0, x1 - x0, y1 - y0).data;
            var r = 0, g = 0, b = 0, n = 0;
            for (var i = 0; i < d.length; i += 4) {
              if (d[i + 3] < 24) continue; // skip near-transparent pixels
              r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
            }
            if (!n) return null;
            return boost(r / n, g / n, b / n);
          }
          cb({
            top: region(0, 0, w, 9),
            right: region(w - 9, 0, w, h),
            bottom: region(0, h - 9, w, h),
            left: region(0, 0, 9, h)
          });
        } catch (e) { /* tainted canvas — leave card as-is */ }
      });
    };
    img.onerror = function () {};
    img.src = src;
  }

  function srcFor(card) {
    var im = card.querySelector('img');
    if (im) {
      var s = im.currentSrc || im.src;
      if (s && !/\.svg(\?|$)/i.test(s) && !/data:image\/svg/i.test(s)) return s;
    }
    var bg = getComputedStyle(card).backgroundImage;
    var m = bg && bg.match(/url\(["']?(.*?)["']?\)/);
    if (m && !/\.svg/i.test(m[1])) return m[1];
    return null;
  }

  function processCard(card) {
    if (card.dataset.leak) return;
    var src = srcFor(card);
    if (!src) return;
    card.dataset.leak = '1';
    sample(src, function (cols) {
      if (!cols) return;
      if (cols.top) card.style.setProperty('--leak-top', cols.top);
      if (cols.right) card.style.setProperty('--leak-right', cols.right);
      if (cols.bottom) card.style.setProperty('--leak-bottom', cols.bottom);
      if (cols.left) card.style.setProperty('--leak-left', cols.left);
      card.classList.add('ck-leak-on');
    });
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          processCard(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '100px 0px' });
  }

  function run() {
    var cards = document.querySelectorAll(TARGETS);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (observer) {
        observer.observe(card);
      } else {
        processCard(card);
      }
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run); // re-scan after lazy images resolve
})();
